var _path, _path2, _path3, _path4, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCameraOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.68,11.09l.19,0L12,9.91a1.11,1.11,0,0,0,0-.19,1.37,1.37,0,1,0-1.37,1.37Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.69,18.26,5.24,16.7H5.09a1.37,1.37,0,0,1-1.25-1.47V8.75A1.36,1.36,0,0,1,5.06,7.31h6.79A1.38,1.38,0,0,1,13.1,8.78v.06l1.55-1.55a3.27,3.27,0,0,0-2.73-2H5A3.27,3.27,0,0,0,2,8.78V15.2A3.27,3.27,0,0,0,3.69,18.26Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1,13v2.29a1.35,1.35,0,0,1-1.22,1.44H9.37l-2,2h4.53a3.29,3.29,0,0,0,3-3.45v-4.1Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.28,9.79l-.07.13,0,4,.17.5,4.29,4.34L22,18.2V5.81L20.77,5.3Zm3.88,5.89L18,13.54V10.48l2.14-2.15Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -1.1,
    y: 10.99,
    width: 26.2,
    height: 2.08,
    transform: "translate(-4.99 12.01) rotate(-45.02)",
    fill: "#ff9300"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraOff);
export default __webpack_public_path__ + "static/media/camera-off.f9509aa445110049325a4bc1ab4a827b.svg";
export { ForwardRef as ReactComponent };